import RatingBreakdown from './RatingBreakdown';

export default RatingBreakdown;
